export const textStyle = {
  textTitle: {
    fontSize: 20,
  },
  textContent: {
    fontSize: 18,
  },
};
